var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button-group',[_c('b-button',{on:{"click":_vm.prevClicked}},[_vm._v("<")]),_c('b-button',{staticStyle:{"width":"130px"},on:{"click":_vm.resetClicked}},[_vm._v(_vm._s(_vm.dateLabel))]),_c('b-button',{on:{"click":_vm.nextClicked}},[_vm._v(">")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }